import React from "react";
import trans from "../../../../utils";

export default function PlayBackOptions({ select, setSelection }) {
  return (
    <div className="row text-center history-playback-options">
      <div className="col-lg-6 col-sm-6">
        <div
          className={select === "history" ? "option-active p-3" : "option p-3"}
          onClick={() => {
            setSelection("history");
          }}
        >
          {trans("History")}
        </div>
      </div>
      <div className="col-lg-6 col-sm-6">
        <div
          className={select === "events" ? "option-active p-3" : "option p-3"}
          onClick={() => {
            setSelection("events");
          }}
        >
          {trans("Events")}
        </div>
      </div>
    </div>
  );
}
